enum ServiceStatus {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  TERMINATED = 'TERMINATED',
  NO_TYPE = 'NO TYPE'
}

export default ServiceStatus;
